import type { Variants } from 'framer-motion';

/**
 * Ease-in-out (same curve as CSS `ease-in-out`: `cubic-bezier(0.42, 0, 0.58, 1)`).
 * Used for slide transitions and reduced-motion instant swaps.
 */
export const GUIDED_STEP_MOTION_EASE = [0.42, 0, 0.58, 1] as const;

/** No lateral motion: instant center swap; keeps layers sane for a11y. */
export const guidedStepCardReducedMotionVariants: Variants = {
  initial: { x: 0, zIndex: 1, opacity: 0 },
  animate: { x: 0, zIndex: 2, opacity: 1 },
  exit: { x: 0, zIndex: 0, opacity: 0 },
};
